const steps = [
  {
    num: '01',
    title: 'Audit',
    description:
      'Mevcut sistemi inceliyoruz. Reklam hesapları. Web sitesi. Kreatifler. Hedef kitle. Teklif. Funnel. Veriler.',
  },
  {
    num: '02',
    title: 'Strateji',
    description:
      'Problemi gördükten sonra büyüme modelini kuruyoruz. Hangi kanal? Hangi kitle? Hangi mesaj? Hangi teklif? Hangi KPI?',
  },
  {
    num: '03',
    title: 'Test',
    description:
      'Tek bir fikre güvenip bütçeyi oraya yığmıyoruz. Mesajları, kreatifleri, hedeflemeleri ve kullanıcı deneyimini kontrollü şekilde test ediyoruz.',
  },
  {
    num: '04',
    title: 'Optimize',
    description:
      'Çalışanı bulduktan sonra işi bitirmiyoruz. Çünkü pazar değişir. Kullanıcı değişir. Kreatif eskir. Performans düşer. Strateji de gerektiğinde değişir.',
  },
  {
    num: '05',
    title: 'Scale',
    description:
      'Neyin çalıştığını gördüğümüzde bütçeyi kontrollü şekilde büyütüyoruz. Amaç daha fazla harcamak değil. Daha fazla sonucu, kontrollü bir sistemle üretmek.',
  },
];

export default function ProcessFlow() {
  return (
    <div className="relative">
      {/* Connecting line - desktop */}
      <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
        {steps.map((step, i) => (
          <div
            key={i}
            className="glass-card-hover rounded-2xl p-6 md:p-7 text-center group relative"
          >
            <div className="w-14 h-14 mx-auto bg-primary-500/10 rounded-2xl flex items-center justify-center mb-5 group-hover:bg-primary-500/20 transition-colors duration-300">
              <span className="text-primary-500 font-heading text-xl font-black tracking-tighter">
                {step.num}
              </span>
            </div>
            <h3 className="text-lg font-bold text-foreground-50 mb-3">
              {step.title}
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}